import { v4 as uuidv4 } from 'uuid';
import { getLocalStorage } from './storage.js';
let deviceCode = '';
/**
 * 生成唯一标识
 * @returns
 */
export function generateUUID() {
    return uuidv4();
}
/**
 * 设备号缓存标识
 */
export const deviceCodeCacheKey = 'fe_device_code';
/**
 * 获取设备号
 * @param platform 平台标识
 * @returns
 */
export function getDeviceCode(platform = 'h5') {
    if (!deviceCode) {
        const storage = getLocalStorage();
        let cachedDeviceCode = storage.getItem(deviceCodeCacheKey);
        if (!(cachedDeviceCode && cachedDeviceCode !== '' && cachedDeviceCode !== 'undefined')) {
            deviceCode = `${platform}-${uuidv4()}`;
            storage.setItem(deviceCodeCacheKey, deviceCode);
        }
        else {
            deviceCode = cachedDeviceCode;
        }
    }
    return deviceCode;
}
/**
 * 重置设备号
 * @param platform
 * @returns
 */
export function resetDeviceCode(platform = 'h5') {
    deviceCode = '';
    const storage = getLocalStorage();
    storage.removeItem(deviceCodeCacheKey);
    return getDeviceCode(platform);
}
